import { Stack, Title, Badge } from '@mantine/core';
import { DataTable } from 'mantine-datatable';
import { useTokenHistory } from '@/hooks/useTokens';
import { formatDateTime } from '@/utils/format';
import type { TokenEventType } from '@/types/token';

const typeLabels: Record<TokenEventType, { label: string; color: string }> = {
  manual: { label: 'Manuell', color: 'blue' },
  birthday: { label: 'Geburtstag', color: 'teal' },
  revenue: { label: 'Umsatz', color: 'grape' },
};

export function TokenHistoryPage() {
  const { data: history, isLoading } = useTokenHistory();

  return (
    <Stack gap="md">
      <Title order={2}>Token-Verlauf</Title>

      <DataTable
        withTableBorder
        borderRadius="sm"
        striped
        records={history ?? []}
        fetching={isLoading}
        columns={[
          {
            accessor: 'sentAt',
            title: 'Datum',
            sortable: true,
            render: (event) => formatDateTime(event.sentAt),
          },
          { accessor: 'companyName', title: 'Unternehmen', sortable: true },
          { accessor: 'tokenCount', title: 'Anzahl', sortable: true },
          { accessor: 'sentTo', title: 'Gesendet an' },
          {
            accessor: 'type',
            title: 'Typ',
            render: (event) => {
              const { label, color } = typeLabels[event.type] ?? typeLabels.manual;
              return <Badge color={color} variant="light">{label}</Badge>;
            },
          },
        ]}
        noRecordsText="Keine Token-Aktionen vorhanden"
      />
    </Stack>
  );
}
